<template>
  <div :class="`formulate-input-element formulate-input-element--${context.class}`" :data-type="context.type">
    <FormulateInput
      :name="`input-${context.attributes.name}`"
      :id="`input-${context.attributes.name}`"
      v-model="context.model"
      :label="label"
      :help="help"
      :helpPosition="helpPosition"
      :placeholder="context.slotProps.component.settings.placeholder || null"
      :currency="isCurrencyInput ? 'EUR' : null"
      :locale="isCurrencyInput ? 'es' : null"
      v-bind="context.attributes"
      :type="type"
      :ref="`input-${context.attributes.name}`"
      :value="this.val"
      :validation="makeValidationString"
      :validation-messages="makeValidationMessages"
      @input="handleInput"
      @blur="checkRange"
    />
    <div class="range-wrapper">
      <FormulateInput
        type="range"
        :name="`slider-${context.attributes.name}`"
        :id="`slider-${context.attributes.name}`"
        v-model="context.model"
        v-bind="context.attributes"
        :min="min"
        :max="max"
        :validation="makeValidationString"
        :validation-messages="makeValidationMessages"
        :ref="`slider-${context.attributes.name}`"
      />
      <!-- Input range label -->
      <div v-if="context.slotProps.component.settings.thumbLabel" class="input-thumb__label-wrapper">
        <div class="input-thumb__label" ref="rangeThumbLabel">{{ context.slotProps.component.settings.thumbLabel }}</div>
      </div>
    </div>
    <!-- Slots -->
    <div v-if="context.attributes.slots" class="slots-wrapper" :class="{ 'slots-wrapper--displaced': isCurrencyInput }">
      <InputSlot
        v-for="(slot, i) in context.attributes.slots"
        v-bind="slot.props"
        :key="`input-slot-${i}`"
        :component="slot.component"
        :children="slot.children"
      />
    </div>
  </div>
</template>

<script>
import InputSlot from '@/funnels/components/form/InputSlot';
import { DEFAULT_SLIDER_COLOR } from '@/constants/slider';

export default {
  components: { InputSlot },
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { val: null };
  },
  mounted() {
    this.$nextTick(function() {
      this.updateValueRefs(this.context.model);
      this.context.model = this.context.model || this.context.value;
    });
  },
  watch: {
    'context.model': function() {
      this.updateValueRefs(this.context.model);
    },
    sliderPerc(val) {
      if (this.$refs.rangeThumbLabel) {
        this.$refs.rangeThumbLabel.style.setProperty('--left', `${val}%`);
      }
    },
  },
  computed: {
    sliderPerc() {
      var slider = document.getElementById(`slider-${this.context.attributes.name}`);

      if (!slider) return 0;

      var perc = ((this.context.model - slider.min) / (slider.max - slider.min)) * 100;
      return perc;
    },
    makeValidationString() {
      if (this.context.slotProps.component.settings.disableSliderValidation === true) {
        return undefined;
      }

      let baseString = 'required|number';
      if (this.min) {
        baseString += '|min:' + this.min;
      }
      if (this.max) {
        baseString += '|max:' + this.max;
      }
    },
    makeValidationMessages() {
      try {
        return this.context.attributes.attributes['validation-messages'];
      } catch (ex) {
        return {
          required: 'El campo es obligatorio.',
          number: 'El campo sólo acepta valores numéricos',
          min: 'El número introducido es menor al permitido',
          max: 'El número introducido es mayor al permitido',
        };
      }
    },
    isCurrencyInput() {
      return this.context.slotProps.component.settings.isCurrencyInput || null;
    },
    componentHasBeenSet() {
      return this.count > 1;
    },
    type() {
      return this.isCurrencyInput ? 'currency' : 'number';
    },
    label() {
      return this.context.slotProps.component.settings.label || null;
    },
    help() {
      return this.context.slotProps.component.settings.help || null;
    },
    helpPosition() {
      return this.context.slotProps.component.settings.helpPosition || 'after';
    },
    min() {
      return this.context.slotProps.component.settings.min;
    },
    max() {
      return this.context.slotProps.component.settings.max;
    },
    defaultValue() {
      return this.context.slotProps.component.settings.defaultValue;
    },
    onlyIntegers() {
      return this.context.slotProps.component.settings.onlyIntegers || false;
    },
    sliderColor() {
      return this.context.slotProps.component.settings.sliderColor || DEFAULT_SLIDER_COLOR;
    },
  },
  methods: {
    updateValueRefs() {
      var slider = document.getElementById(`slider-${this.context.attributes.name}`);
      slider.style.background = `linear-gradient(to right, ${this.sliderColor} 0%, ${this.sliderColor} ${this.sliderPerc}%, #E5E7EB ${this.sliderPerc}%, #E5E7EB 100%)`;
    },
    checkRange() {
      if (!this.context.model || this.context.model < this.min) this.context.model = this.min;
      else if (this.context.model > this.max) this.context.model = this.max;
    },
    handleInput(e) {
      if (this.onlyIntegers) {
        this.context.model = this.parseOnlyIntegers(e);
      }

      this.$emit('input', this.context.model);
    },
    parseOnlyIntegers(string) {
      if (!string) return '';
      else {
        const res = parseInt(string);
        if (Number.isInteger(res)) return res;
        else return this.context.value;
      }
    },
  },
};
</script>
